export default __webpack_public_path__ + "asset/img/checkbox-sel~6ee237f2.png";